import { render, staticRenderFns } from "./productGoods.vue?vue&type=template&id=2d346040&"
import script from "./productGoods.vue?vue&type=script&lang=js&"
export * from "./productGoods.vue?vue&type=script&lang=js&"
import style0 from "./productGoods.vue?vue&type=style&index=0&id=2d346040&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports